import { useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import { isRefreshSelector, setIsRefresh, setStations, useStationStore } from 'stores/station';

import { useAuthStore, userProfileSelector } from 'modules/auth/core';
import { Station } from 'modules/institution-info/core/type';

import { apiCall } from 'hooks/service';

import { PATH } from 'constants/path';

import { getInstitutionDetail } from './helper';

export const useInstitutionInfoLayoutController = () => {
  const location = useLocation();

  const navigationTo = useNavigate();

  const isRefresh = useStationStore(isRefreshSelector);
  const userProfile = useAuthStore(userProfileSelector);

  const params = useParams();
  const { institutionId } = params;

  const institutionName = userProfile?.institution?.name;

  const isInstitutionDetail = location.pathname.includes(`${PATH.INSTITUTIONS}`);

  useEffect(() => {
    if (isInstitutionDetail && institutionId) {
      getInstitutionDetail(institutionId);
    }
  }, [institutionId, isInstitutionDetail]);

  useEffect(() => {
    if (isRefresh) {
      getListStation();
      setIsRefresh(false);

      return;
    }

    getListStation();
  }, [isRefresh]);

  const getListStation = async () => {
    const result: Station[] = await apiCall({
      url: `/stations`,
      method: 'GET',
      showError: true,
      isLoading: true,
      data: {
        institutionId: isInstitutionDetail ? institutionId : '',
      },
    });

    setStations(result);
  };

  const onTabClick = (key: string) => {
    navigationTo(key);
  };

  const goBack = () => {
    navigationTo(`${PATH.INSTITUTIONS}`);
  };

  return { institutionName, isInstitutionDetail, institutionId, onTabClick, goBack };
};
